import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  Output,
  effect,
  inject,
  input,
} from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import { MatSort, MatSortHeader } from '@angular/material/sort'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'
import { MatTooltip } from '@angular/material/tooltip'
import {
  DataContextBuilder,
  ElderDataToolbarComponent,
  ElderNumberCellDirective,
  ElderQuantityPipe,
  ElderTableComponent,
  ElderTableToolbarDirective,
  ElderToastService,
  IDataContext,
  Sort,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { Package } from '../package'
import {
  IPackageDialogOptions,
  PackageDetailDialogComponent,
} from '../package-detail-dialog/package-detail-dialog.component'
import { PackageFilterBuilder } from '../package-filter-builder'
import { PackageService } from '../package.service'

@Component({
  selector: 'app-package-browser',
  templateUrl: './package-browser.component.html',
  styleUrls: ['./package-browser.component.scss'],
  imports: [
    ElderTableComponent,
    MatSort,
    ElderTableToolbarDirective,
    ElderDataToolbarComponent,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIcon,
    MatSortHeader,
    ElderNumberCellDirective,
    MatTooltip,
    ElderTranslatePipe,
    ElderQuantityPipe,
  ],
})
export class PackageBrowserComponent implements OnDestroy {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly data: IDataContext<Package>
  public readonly canAdd = input<boolean>()
  public readonly canRemove = input<boolean>()
  public readonly workOrderId = input.required<string>()
  public readonly company = input.required<string>()
  @Output()
  public requestNew: EventEmitter<void> = new EventEmitter<void>()

  private toastService = inject(ElderToastService)
  private dialog = inject(MatDialog)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const packageService = inject(PackageService)
    this.data = DataContextBuilder.start<Package>()
      .pageSize(30)
      .reloadOnLocalChanges()
      .autoStartOnFiltersAll([PackageFilterBuilder.WORK_ORDER_ID], [new Sort('number', 'asc')])
      .build(packageService)

    effect(() => {
      if (this.workOrderId()) {
        this.data.filter.updateFilter(PackageFilterBuilder.workOrderId(this.workOrderId()))
      }
    })
  }

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnDestroy(): void {
    if (this.data) {
      this.data.close()
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onRequestNew() {
    this.requestNew.emit()
  }

  public openSideDetail(pkg: Package): void {
    this.toastService.info('Not implemented!')
  }

  public openDetail(pkg: Package, company: string): void {
    if (pkg) {
      const dialogRef = this.dialog.open(PackageDetailDialogComponent, {
        maxWidth: '95vw',
        maxHeight: '95vw',
        width: '95vw',
        height: '95vh',
        data: <IPackageDialogOptions>{
          pkgId: pkg.id,
          company,
        },
      })
    }
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/
}
